var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warningText"},[_c('i',{staticClass:"fal fa-info-circle warningIcon"}),_c('br'),_c('h1',[_vm._v("Uwaga")]),_c('br'),_c('h3',[_vm._v(_vm._s(_vm.schema.text.$model))])])}
var staticRenderFns = []

export { render, staticRenderFns }